export default __webpack_public_path__ + "static/media/aqaenglish.9b2018df.png";